import { render, staticRenderFns } from "./InstallButton.vue?vue&type=template&id=6034b46b"
import script from "./InstallButton.vue?vue&type=script&lang=js"
export * from "./InstallButton.vue?vue&type=script&lang=js"
import style0 from "./InstallButton.vue?vue&type=style&index=0&id=6034b46b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports